import React, {Component} from 'react';
import Logo from "./components/logo";

import './App.css';
import Section from "./components/section";
import Contact from "./components/contact";

class App extends Component {
    render() {
        
        const content = [
            {
              title: 'Závlahové systémy TORO',
              items: [
                  'konzultace vhodného řešení',
                  'vypracování návrhu závlahy',
                  'realizace a servis systému',
                  'sezónní a posezónní údržba',
                  'náhradní díly a příslušenství',
                  'individuální zákaznický program',
              ]
            },
            {
                title: 'Automatické sekačky Husqvarna',
                items: [
                    'předprodejní konzultace',
                    'poradenství a doporučení',
                    'zprostředkování prodeje',
                    'odborná instalace a servis',
                    'sezónní a posezónní údržba',
                    'náhradní díly a příslušenství',
                ]
            },
            {
                title: 'Realizace a údržba okrasných zahrad',
                items: [
                    'konzultace a návrh úprav',
                    'příprava a realizace zahrad',
                    'kompletní péče a správa zeleně',
                    'zajištění realizačních materiálů',
                    'doprava a likvidace materiálů',
                    'individuální zákaznický program',
                ]
            },
        ];

        const sections = content.map((item, key) => {
            return (
                <div className="col-md-4">
                    <Section title={item.title} items={item.items}/>
                </div>
            );
        });
        
        return (
            <div className="App">
                <header className="App__header">
                    <div className="App__logo">
                        <Logo/>
                    </div>
                </header>
                <div className="App__body">
                    <div className="row App__body__row">
                        {sections}
                    </div>
                    <div className="row App__body__row">
                        <div className="col-12">
                            <Contact/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
